import React, { FC } from "react";
import { styled } from "@material-ui/styles";

import KPICard from "../../elements/KPICard";
import { DashboardMetrics } from "./campaignUtils";

type AdvertiserDashboardMetricsProps = DashboardMetrics;

const Root = styled("div")({
  display: "flex",
  gap: 16,
  flexWrap: "wrap",
  marginBottom: 24,
});

const AdvertiserDashboardMetrics: FC<AdvertiserDashboardMetricsProps> = ({
  activeCampaignCount,
  totalImpressions,
  totalClicks,
  spendMtd,
}) => (
  <Root>
    <KPICard label="Active Campaigns" value={activeCampaignCount} />
    <KPICard label="Total Impressions" value={totalImpressions} />
    <KPICard label="Total Clicks" value={totalClicks} />
    <KPICard label="Spend (All Time)" value={spendMtd} />
  </Root>
);

export default AdvertiserDashboardMetrics;
